import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Image from '../../components/common/image/Image';
import GenericHeader from '../../components/common/pageHeader/GenericHeader';

//Constants
import { configs } from '../../constants/configs/configs';
import { Button }from '@cmsgov/design-system';


const SsapSummaryFallback = props => {
    const {
        restoreAction,
        stateCode
    } = props;

    const errorImage = configs.ENV.DEVELOPMENT
        ? `../../../assets/images/${ String(stateCode).toLowerCase() }-error-illustration.png`
        : configs.endpoints.IMAGES.processReplacements({
            relativePath: '/resources/img',
            fileName: `${ String(stateCode).toLowerCase() }-error-illustration.png`
        });

    return (
        <Fragment>
            <main
                className = 'usa-layout-docs usa-section gi-main-section'
                id = 'gi-ssap-summary-fallback__container'
            >
                <div className = 'grid-container gi-grid-container' >
                    <div className = 'grid-row grid-gap gi-wrapper gi-fallback' >
                        <div className = 'desktop:grid-col-4 tablet:grid-col-4 mobile:grid-col-12 gi-fallback__item gi-fallback__content' >
                            <GenericHeader
                                tag = 'h2'
                                id = 'error-header'
                                text = 'session.error.header'
                                headerClassName = { [ 'mobile:grid-col-12 tablet:grid-col-fill gi-fallback__content__header' ] }
                            />
                            <Button
                                className = 'usa-button gi-button gi-button__primary'
                                onClick = { restoreAction }
                            >
                                <FormattedMessage id = 'button.refresh_summary' />
                            </Button>
                        </div>
                        <div className = 'desktop:grid-col-5 tablet:grid-col-5 mobile:grid-col-12 gi-fallback__item gi-fallback__item gi-fallback__img' >
                            <Image
                                { ...
                                    {
                                        source: errorImage,
                                        desc: 'session.error.content.img.desc',
                                        name: 'system__error_img',
                                        classes: []
                                    }
                                }
                            />
                        </div>
                    </div>
                </div>
            </main>
        </Fragment>
    );
};

export default SsapSummaryFallback;